import * as React from 'react';
import type { SVGProps } from 'react';
const SvgClose = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={13} fill="none" {...props}>
    <path fill="#FE5000" d="M.293 1.5 1 .793l11 11-.707.707z" />
    <path fill="#FE5000" d="m11.293.5.707.707-11 11-.707-.707z" />
  </svg>
);
export default SvgClose;
